/* eslint-disable import/no-named-as-default */
/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fab from '@material-ui/core/Fab';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ProfileForm from '../UserProfileForm';
import Header from '../Header';
import Loading from '../../components/Loading';

import { editProfile, getProfile } from '../../actions/profile';
import ProfileGrid from '../../components/ProfileGrid';

const useStyles = makeStyles(theme => ({
  hide: {
    display: 'none',
  },
  wrapper: {
    marginTop: theme.spacing(3),
  },
  title: {
    padding: theme.spacing(2),
  },
  loading: {
    marginTop: theme.spacing(7),
    position: 'fixed',
    left: '50%',
  },
  fab: {
    width: '60px',
    height: '60px',
    bottom: '30px',
    right: '10px',
  },
}));

export const Profile = props => {
  const { isEditing, profile, isLoading, editProfile, getProfile, uid } = props;
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    getProfile(uid);
  }, [getProfile, uid]);

  return (
    <>
      <Header />
      <Loading />
      {isEditing ? <ProfileForm profile={profile} /> : null}
      <Container
        className={clsx(classes.wrapper, {
          [classes.hide]: isEditing,
        })}
        maxWidth="lg"
      >
        <CircularProgress
          className={clsx(classes.loading, {
            [classes.hide]: !isLoading,
          })}
        />
        <Grid>
          <Grid container item xs={12} spacing={0} wrap="nowrap">
            <Typography className={classes.title} variant="h5" component="h3" sm={8}>
              User Profile
            </Typography>
          </Grid>
        </Grid>
        <div className={clsx({ [classes.hide]: isLoading })}>
          <ProfileGrid profile={profile} />
        </div>

        <Grid
          container
          justify="flex-end"
          className={clsx({
            [classes.hide]: isLoading,
          })}
        >
          <div>
            <Fab
              color="primary"
              aria-label="actions"
              className={classes.fab}
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={event => setAnchorEl(event.currentTarget)}
            >
              <MoreVertIcon />
            </Fab>
            <Menu
              getContentAnchorEl={null}
              id="action-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              variant="selectedMenu"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  editProfile();
                }}
              >
                Edit User Profile
              </MenuItem>
            </Menu>
          </div>
        </Grid>
      </Container>
    </>
  );
};

Profile.defaultProps = {
  uid: '',
  profile: {},
  isEditing: false,
  isLoading: false,
  editProfile: () => {},
  getProfile: () => {},
};

Profile.propTypes = {
  uid: PropTypes.string,
  profile: PropTypes.shape({
    user_id: PropTypes.string,
    email: PropTypes.string,
    created: PropTypes.string,
    roles: PropTypes.shape({
      app: PropTypes.arrayOf(PropTypes.string),
    }),
  }),
  isEditing: PropTypes.bool,
  editProfile: PropTypes.func,
  getProfile: PropTypes.func,
  isLoading: PropTypes.bool,
};

const mapStateToProps = state => {
  const { profile, auth } = state;
  return {
    uid: auth.profile.sub,
    profile: profile.profile,
    isLoading: profile.isLoading,
    isEditing: profile.isEditing,
  };
};

const mapDispatchToProps = {
  editProfile,
  getProfile,
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
